import { render } from "./DjBatchRechargeTab.vue?vue&type=template&id=9f59671c&scoped=true"
import script from "./DjBatchRechargeTab.vue?vue&type=script&lang=js"
export * from "./DjBatchRechargeTab.vue?vue&type=script&lang=js"

import "./DjBatchRechargeTab.vue?vue&type=style&index=0&id=9f59671c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9f59671c"

export default script